import GridLayout from 'react-grid-layout';
import { inverseModuleStatuses } from '../../enums';
import { Row, StatusDot } from '../../styles';
import { getModuleRowBackgroundColor } from '../../utils';
import {MANIFOLD_HEIGHT, TILE_HEIGHT, TILE_WIDTH} from '../consts';

import VisualLayout from '../VisualLayout';
import { Wrapper, DroppedItem, ContentWrapper, SiScore, TsCode } from './styles';

const Dropzone = ({
  nrOfFrames,
  position,
  layout,
  setLayout,
  classes,
  onDropZoneItemClick,
  onDropZoneClick,
  onDropFromOutside,
  onDropFromInside,
  isAbovePipes = true,
  isManifold = false,
}) => {
  const onDrop = (_, layoutItem, _event) => {
    const projectData = JSON.parse(_event.dataTransfer.getData('text'));
    onDropFromOutside(layoutItem, projectData);
  };

  const onDragStop = (newLayout, oldItem, newItem, placeholder, event, element) => {
    setLayout((currentLayout) =>
      currentLayout.map((currentItem) => {
        const newItem = newLayout.find((i) => i.i === currentItem.i);
        if (!newItem) return null;
        return {
          ...currentItem,
          ...newItem,
        };
      })
    );
    onDropFromInside({ id: newItem.i, x: newItem.x + 49 });
  };
  let zoneHeight = isManifold ? MANIFOLD_HEIGHT : TILE_HEIGHT;

  return (
    <Wrapper
      //   onClick={onDropZoneClick}
      style={{
        ...position,
      }}>
      <VisualLayout id='dropzone-layout' isManifold={isManifold} nrOfFrames={nrOfFrames} />
      <GridLayout
        className={`dropzone ${classes}`}
        layout={layout}
        cols={nrOfFrames}
        width={nrOfFrames * TILE_WIDTH}
        rowHeight={zoneHeight}
        maxRows={1}
        margin={[0, 5]}
        isResizable={false}
        isDroppable={true}
        // compactType='horizontal'
        preventCollision={true}
        allowOverlap={false}
        style={{
          height: zoneHeight,
          top: 0,
          width: nrOfFrames * TILE_WIDTH,
          position: 'absolute',
          overflow: 'visible',
        }}
        isBounded={true}
        useCSSTransforms
        onDropDragOver={() => ({ w: 5, h: 1 })}
        onDragStop={onDragStop}
        onDrop={onDrop}>
        {layout.map((module) => {
          return (
            <DroppedItem
              isManifold={isManifold}
              key={module.i}
              bg={getModuleRowBackgroundColor(module)}
              onDoubleClick={(e) => {
                e.stopPropagation();
                onDropZoneItemClick(module.id);
              }}>
              {((isAbovePipes && module.includesRiserManifold) || (!isAbovePipes && module.includesPiperack)) && (
                <div
                  style={{
                    position: 'absolute',
                    top: isAbovePipes ? `-${zoneHeight * 0.75}px` : '-0.75rem',
                    width: '100%',
                    height: isAbovePipes ? `${zoneHeight * 0.75}px` : '0.75rem',
                    background: 'inherit',
                  }}></div>
              )}
              <ContentWrapper>
                <Row justify='space-between'>
                  <StatusDot
                    size='0.8rem'
                    color={inverseModuleStatuses[module.status]?.color}
                  />
                  <SiScore>{module.siScore ?? '-'}%</SiScore>
                </Row>
                <Row justify='end'>
                  <TsCode>{module.tsCode}</TsCode>
                </Row>
              </ContentWrapper>
              {((isAbovePipes && module.includesPiperack) || (!isAbovePipes && module.includesRiserManifold)) && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: isAbovePipes ? '-0.75rem' : `-${zoneHeight * 0.75}px`,
                    width: '100%',
                    height: isAbovePipes ? '0.75rem' : `${zoneHeight * 0.75}px`,
                    background: 'inherit',
                  }}></div>
              )}
            </DroppedItem>
          );
        })}
      </GridLayout>
    </Wrapper>
  );
};

export default Dropzone;
